import React, { useContext, useEffect, useState } from 'react';
import axiosClient from '../../config/axiosClient';
import StudentContext from '../../context/student/studentContext';
import TeacherContext from '../../context/teacher/teacherContext';
import EvaluationContext from '../../context/evaluation/evaluationContext';
import {makeStyles} from '@material-ui/core/styles';
import {Table, TableContainer, TableHead, TableCell, TableBody, TableRow, Modal, Button, Tooltip } from '@material-ui/core';
import {Add, Delete, Done, FormatListNumbered, RemoveCircle, VerifiedUser, Warning} from '@material-ui/icons';
import ReactExport from "react-export-excel";
import * as AiIcons from 'react-icons/ai';
import Box from '@material-ui/core/Box';
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import ListaMentores from './ListaMentores';
import ListaEvaluaciones from '../modal/ListaEvaluaciones';

const useStyles = makeStyles((theme) => ({
    modal: {
        position: 'absolute',
        width: '70%',
        height: '70%',
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        borderRadius: 10,
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        overflowY: 'scroll'
    },
    modalAlerta: {
        position: 'absolute',
        width: 600,
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        borderRadius: 10,
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        overflowY: 'scroll'
    },
    icono:{
        cursor: 'pointer'
    },
    warning:{
        color: 'orange'
    },
    done:{
        color: 'green'
    },
    inputMaterial:{
        width: '100%'
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
    options: {
    width: 180,
        textAlign: 'left'
    }
}));

const capitalize = (s) => {
    if (typeof s !== 'string') return ''
    return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase()
}

function ListaAlumnos() {

    useEffect(() => {
        listarStudents();
        listarTeachers();
        // eslint-disable-next-line
    },[]);

    const studentContext = useContext(StudentContext);
    const { allStudents, listarStudents } = studentContext;

    const teacherContext = useContext(TeacherContext);
    const { allTeachers, listarTeachers } = teacherContext;

    const evaluationContext = useContext(EvaluationContext);
    const { obtenerEvaluaciones } = evaluationContext;

    const styles= useStyles();

    const [ modalEditar, setModalEditar ] = useState(false);
    const [ modalDesasignar, setModalDesasignar ] = useState(false);
    const [ modalEliminar, setModalEliminar ] = useState(false);
    const [ modalEliminarTodos, setModalEliminarTodos ] = useState(false);
    const [ modalEvaluaciones, setModalEvaluaciones ] = useState(false);

    const [ student, setStudent ] = useState({});

    const asignarMentor=async()=>{
        await axiosClient.post('/api/student/asigneTeacher', student)
            .then(response=>{
                listarStudents();
                abrirCerrarModalEditar()
        }).catch(error => { console.log(error); })
    }

    const limpiarMentor=async()=>{
        await axiosClient.post('/api/student/cleanTeacher', student)
            .then(response=>{
                listarStudents();
                abrirCerrarModalDesasignar()
        }).catch(error => { console.log(error); })
    }

    const bajaLogica=async()=>{
        await axiosClient.delete('/api/auth/logicDelete/' + student._id)
            .then(response=>{
                listarStudents();
                abrirCerrarModalEliminar()
        }).catch(error => { console.log(error); })
    }

    const bajaLogicaTodos=async()=>{
        await axiosClient.delete('/api/auth/logicDeleteAll/Student')
            .then(response=>{
                listarStudents();
                abrirCerrarModalEliminarTodos()
        }).catch(error => { console.log(error); })
    }

    const aprobarMentor=async(datos)=>{
        setStudent(datos)
        await axiosClient.post('/api/student/approveTeacher', student)
            .then(response=>{
                listarStudents();
        }).catch(error => { console.log(error); })
    }

    const onChangeTeacher = e => {
        setStudent({
            ...student,
            [e.target.name]: e.target.value
        })
    }

    const abrirCerrarModalEditar=()=>{
        setModalEditar(!modalEditar);
    }

    const abrirCerrarModalDesasignar=()=>{
        setModalDesasignar(!modalDesasignar);
    }

    const abrirCerrarModalEliminar=()=>{
        setModalEliminar(!modalEliminar);
    }

    const abrirCerrarModalEliminarTodos=()=>{
        setModalEliminarTodos(!modalEliminarTodos);
    }

    const abrirCerrarModalEvaluaciones=()=>{
        setModalEvaluaciones(!modalEvaluaciones);
    }
    
    const seleccionarMentor=(data)=>{
        setStudent(data);
        abrirCerrarModalEditar()
    }

    const seleccionarAlumno=(data)=>{
        setStudent(data);
        abrirCerrarModalDesasignar()
    }

    const consultarEvaluaciones=(id)=>{
        obtenerEvaluaciones(id);
        abrirCerrarModalEvaluaciones();
    }

    const eliminarUsuario=(data)=>{
        setStudent(data)
        abrirCerrarModalEliminar();
    }

    const eliminarTodosUsuarios=()=>{
        abrirCerrarModalEliminarTodos();
    }

    const modalAsignarMentor = (
        <div className={styles.modal}>
            <div className="main-navbar sticky-top ">
                <nav className="navbar align-items-stretch navbar-light flex-md-nowrap p-0" >
                    <div className="container-fluid" style={{justifyContent: 'center'}}>
                        <div className="card" id="resumen">
                            <div className="card-body" style={{padding: '.875em'}}>
                                <div className="row">
                                    <div className="col-md-6">
                                        <h5 className="card-title">Alumno: {student && `${student.name} ${student.last_name}`}</h5><br/>
                                        <h6 className="card-subtitle mb-2 text-muted text-capitalize">{student && `Mencion: ${student.mention} - Carrera: ${student.career}`}</h6>
                                    </div>
                                    <div className="col-md-3">
                                        {student?.industry?.map((x, i) => (
                                            <span className="badge bg-light text-dark" key={i+100} >▪ {x}</span>
                                        ))}
                                    </div>
                                    <div className="col-md-3">
                                        {student?.area?.map((x, i) => (
                                            <span className="badge bg-light text-dark" key={i+200} >▪ {x}</span>
                                        ))}
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-3">
                                        <p className="small"><b>Inquietudes: </b>{student.concerns}</p>
                                    </div>
                                    <div className="col-md-3">
                                        <p className="small"><b>Metas profesionales: </b>{student.goals}</p>
                                    </div>
                                    <div className="col-md-3">
                                        <p className="small"><b>Estudios adicionales: </b>{student.extra_studies}</p>
                                    </div>
                                    <div className="col-md-3">
                                        <p className="small"><b>Proyección a 5 años: </b>{student.projection}</p>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-8">
                                        <div className="row">
                                            <div className="col-md-8">
                                                <select
                                                    name="matched_teacher"
                                                    className="form-control form-control-sm"
                                                    title="Asigne un mentor al alumno"
                                                    value={student && student.matched_teacher}
                                                    onChange={onChangeTeacher}
                                                    required
                                                >
                                                    <option value="" disabled="disabled">Seleccione un mentor...</option>
                                                    { allTeachers?.map((item, index) => {
                                                    return (
                                                        <option value={item.email} key={index+1000} >{capitalize(item.name)} {capitalize(item.last_name)} ({item.email})</option>
                                                    );
                                                    })}                
                                                </select>
                                            </div>
                                            <div className="col-md-4">
                                                { student.matched_teacher !== "" && (
                                                        <Button color="primary" onClick={()=>asignarMentor()}>Asignar</Button>
                                                    )}
                                                <Button color="secondary" onClick={()=>abrirCerrarModalEditar()}>Cancelar</Button>
                                            </div>
                                        </div>

                                        
                                    </div>
                                    <div className="col-md-4">
                                        Mentor seleccionado: { student.matched_teacher }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </nav>
            </div>
            <div className="row" style={{marginTop: 200}}>
                <div className="col-12">
                    <ListaMentores />
                </div>
            </div>
        </div>
    )

    const bodyDesasignar=(
        <div className={styles.modalAlerta}>
            <p>¿Está seguro que desea eliminar el mentor asignado a <b>{student && student.name}</b>? </p>
            <div align="right">
                <Button color="secondary" onClick={()=>limpiarMentor()} >Sí</Button>
                <Button onClick={()=>abrirCerrarModalDesasignar()}>No</Button>
            </div>
        </div>
    )

    const bodyEliminar=(
        <div className={styles.modalAlerta}>
            <p>¿Está seguro que desea eliminar a <b>{student && `${student.name} ${student.last_name}`}</b>? </p>
            <div align="right">
                <Button color="secondary" onClick={()=>bajaLogica()} >Sí</Button>
                <Button onClick={()=>abrirCerrarModalEliminar()}>No</Button>
            </div>
        </div>
    )

    const bodyEliminarTodos=(
        <div className={styles.modalAlerta}>
            <p>¿Está seguro que desea eliminar todos los alumnos registrados? </p>
            <div align="right">
                <Button color="secondary" onClick={()=>bajaLogicaTodos()} >Sí</Button>
                <Button onClick={()=>abrirCerrarModalEliminarTodos()}>No</Button>
            </div>
        </div>
    )

    const modalListaEvaluaciones = (
        <div className={styles.modal}>
            
            <div className="row" >
                <div className="col-12">
                    <ListaEvaluaciones />
                </div>
            </div>
        </div>
    )

    function ExportExcel() {

        const ExcelFile = ReactExport.ExcelFile;
        const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
        const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

        const fecha = new Date();  

        const fileName = "Mentoring Program " + fecha.toLocaleString('es-MX');

        //ref: https://github.com/rdcalle/react-export-excel/blob/HEAD/examples/with_custom_download_element.md
        return (
            <>
                <ExcelFile 
                    element={
                        <Button 
                            id="export-excel"
                            startIcon={<AiIcons.AiOutlineFileExcel />}
                            variant="contained"
                            title="Excel" />
                    } 
                    filename={fileName}>
                    
                    <ExcelSheet data={allStudents} name="Alumnos">
                        <ExcelColumn label="Nombre" value="name"/>
                        <ExcelColumn label="Apellido" value="last_name"/>
                        <ExcelColumn label="Matricula" value="student_id"/>
                        <ExcelColumn label="Fecha de nacimiento" value="birth_date"/>
                        <ExcelColumn label="Teléfono" value="phone"/>
                        <ExcelColumn label="Email" value="email"/>
                        <ExcelColumn label="Carrera" value="career"/>
                        <ExcelColumn label="Año" value="year"/>
                        <ExcelColumn label="Mención" value="mention"/>
                        <ExcelColumn label="Industria" value="industry"/>
                        <ExcelColumn label="Area" value="area"/>
                        <ExcelColumn label="Mentor asignado" value="matched_teacher"/>
                        <ExcelColumn label="Match" value="matched_status"/>
                    </ExcelSheet>
                    <ExcelSheet data={allTeachers} name="Mentores">
                        <ExcelColumn label="Nombre" value="name"/>
                        <ExcelColumn label="Apellido" value="last_name"/>
                        <ExcelColumn label="Email" value="email"/>
                        <ExcelColumn label="Email laboral" value="laboral_email"/>
                        <ExcelColumn label="Teléfono" value="phone"/>
                        <ExcelColumn label="Carrera" value="career"/>
                        <ExcelColumn label="Universidad" value="college"/>
                        <ExcelColumn label="Industria" value="industry"/>
                        <ExcelColumn label="Area" value="area"/>
                    </ExcelSheet>
                </ExcelFile>
            </>
        );
    }

    function Row(props) {
        const { row } = props;
        const [open, setOpen] = useState(false);
            
        return (
            <>
                <TableRow key={row._id}>
                    <TableCell>
                        <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
                            {open ? <AiIcons.AiOutlineUp /> : <AiIcons.AiOutlineDown />}
                        </IconButton>
                    </TableCell>
                    <TableCell>{capitalize(row.name)} {capitalize(row.last_name)}</TableCell>
                    <TableCell>
                        {row.industry.map((x, i) => (
                            <span className="badge bg-light text-dark" key={i+300} >▪ {x}</span>
                        )        
                    )}</TableCell>
                    <TableCell>
                        {row.area.map((x, i) => (
                            <span className="badge bg-light text-dark" key={i+400} >▪ {x}</span>
                        )        
                    )}</TableCell>
                    {/* <TableCell>{row.matched_teacher}</TableCell> */}
                    <TableCell align="left" className={styles.options}>
                        { row.match_status === "Pendiente" ? (
                            <Tooltip title="Pendiente">
                                <Warning className={styles.warning} />
                            </Tooltip>
                        ) : (
                            <Tooltip title="Aprobado">
                                <VerifiedUser className={styles.done} />
                            </Tooltip>
                        )}{row.matched_teacher}</TableCell>
                    <TableCell align="right">
                        { row.match_status === "Pendiente" && row.matched_teacher !== "" && (
                            <Tooltip title="Aprobar mentor">
                                <Done className={styles.icono} onClick={()=>aprobarMentor(row)} />
                            </Tooltip>
                        )}
                        { row.matched_teacher !== "" ? (
                            <Tooltip title="Eliminar mentor">
                                <RemoveCircle className={styles.icono} onClick={()=>seleccionarAlumno(row)} />
                            </Tooltip>
                        ) : (
                            <Tooltip title="Asignar mentor">
                                <Add className={styles.icono} onClick={()=>seleccionarMentor(row)} />
                            </Tooltip>
                        )}
                        <Tooltip title="Consultar evaluaciones realizadas">
                            <FormatListNumbered className={styles.icono} onClick={()=>consultarEvaluaciones(row._id)} />
                        </Tooltip>
                        <Tooltip title="Eliminar usuario">
                            <Delete className={styles.icono} onClick={()=>eliminarUsuario(row)} />
                        </Tooltip>
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>  
                        <Collapse in={open} timeout="auto" unmountOnExit>
                            <Box margin={1}>
                                <div className="card-group justify">
                                    <div className="card">
                                        <div className="card-body">
                                            <h6 className="card-title">Principales inquietudes</h6>
                                            <p className="card-text">{row.concerns}</p>
                                        </div>
                                    </div>
                                    <div className="card">
                                        <div className="card-body">
                                            <h6 className="card-title">Metas profesionales</h6>
                                            <p className="card-text">{row.goals}</p>
                                        </div>
                                    </div>
                                    <div className="card">
                                        <div className="card-body">
                                            <h6 className="card-title">Realizaría algún estudio extra</h6>
                                            <p className="card-text">{row.extra_studies}</p>
                                        </div>
                                    </div>
                                    <div className="card">
                                        <div className="card-body">
                                            <h6 className="card-title">Proyeccion laboral a 5 años</h6>
                                            <p className="card-text">{row.projection}</p>
                                        </div>
                                    </div>
                                </div>
                            </Box>
                        </Collapse>
                    </TableCell>
                </TableRow>
            </>
        );
    }

    return (
        <>
            <div className="container">
                <div className="row">
                    <div className="col-lg-12 col-md-12 col-sm-12 mb-12">
                        <div className="card card-small">
                            <div className="card-header border-bottom">
                                <h5 className="m-0">Lista de Alumnos inscritos</h5>
                            </div>

                            <div className="">
                                <ExportExcel />
                                <Button 
                                    id="delete-users"
                                    startIcon={<Delete />}
                                    variant="contained"
                                    title="Eliminar todos los alumnos"
                                    type="textSecondary"
                                    onClick={()=>eliminarTodosUsuarios()} />
                            </div>

                            <div className="card-body p-0 pb-3 text-center">
                                <TableContainer className="table-responsive">
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell/>
                                                <TableCell>Nombre</TableCell>
                                                <TableCell>Industrias</TableCell>
                                                <TableCell>Áreas</TableCell>
                                                <TableCell>Mentor</TableCell>
                                                <TableCell className={styles.options}>Acciones</TableCell>
                                            </TableRow>
                                        </TableHead>

                                        <TableBody>
                                        {allStudents && allStudents.map((row) => (
                                            <Row key={row._id} row={row} />
                                        ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br />
            <br />
            <br />

            <Modal
                open={modalDesasignar}
                onClose={abrirCerrarModalDesasignar}>
                    {bodyDesasignar}
            </Modal>

            <Modal
                open={modalEliminar}
                onClose={abrirCerrarModalEliminar}>
                    {bodyEliminar}
            </Modal>

            <Modal
                open={modalEliminarTodos}
                onClose={abrirCerrarModalEliminarTodos}>
                    {bodyEliminarTodos}
            </Modal>

            <Modal
                open={modalEditar}
                onClose={abrirCerrarModalEditar}>
                    {modalAsignarMentor}
            </Modal>

            <Modal
                open={modalEvaluaciones}
                onClose={abrirCerrarModalEvaluaciones}>
                    {modalListaEvaluaciones}
            </Modal>

        </>
    )
}

export default ListaAlumnos